// Created by Michael Abadi Santoso
// 25 May 2020
// Copyright OKKAMI

import React, { Component } from "react";
import styled from "styled-components";
import { isEmpty, isUndefined } from "lodash";

import { Link } from "react-router-dom";
import Property from "../../model/property";

class BottomBar extends Component {
  state = {
    preset: {},
  };

  componentDidMount() {
    if (isEmpty(this.state.preset) && !isUndefined(Property.getPreset())) {
      this.setState({ preset: Property.getPreset() });
    }
  }

  componentDidUpdate() {
    if (isEmpty(this.state.preset) && !isUndefined(Property.getPreset())) {
      this.setState({ preset: Property.getPreset() });
    }
  }
  render() {
    const { preset } = this.state;
    let children = (
      <FlexContainer className={"textStyle"}>
        {this.props.count !== "0" && (
          <SmallTitle app_home_text_top_nav={preset.text_color}>
            {this.props.count}
          </SmallTitle>
        )}
        <SmallTitle app_home_text_top_nav={preset.text_color}>
          {this.props.title}
        </SmallTitle>
        {this.props.count !== "0" && (
          <SmallTitle app_home_text_top_nav={preset.text_color}>
            {this.props.price}
          </SmallTitle>
        )}
      </FlexContainer>
    );
    const product =
      this.props.productArray && this.props.productArray.length !== 0
        ? this.props.productArray
        : [];

    if (this.props.url !== undefined) {
      let url = this.props.baseUrl;
      let title = this.props.listTitle;
      return (
        <NavBarLink
          id="bottom-bar-link"
          to={{
            pathname: `${this.props.url}`,
            productArray: { product },
            fromProductList: { url },
            listTitle: { title },
            backFrom: this.props.currentPage,
          }}
          onClick={this.props.handler}
          app_home_color_primary={preset.app_home_color_primary}>
          {children}
        </NavBarLink>
      );
    } else {
      return (
        <Button
          id="bottom-bar-link"
          onClick={this.props.handler}
          disabled={this.props.disabled}
          app_home_color_primary={preset.app_home_color_primary}>
          {children}
        </Button>
      );
    }
  }
}

export default BottomBar;

const SmallTitle = styled.div`
  margin: auto;
  text-align: center;
  color: ${(props) =>
    props.app_home_text_top_nav ? props.app_home_text_top_nav : "white"};
  font-size: 1.5rem;
`;

const NavBarLink = styled(Link)`
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  background: ${(props) =>
    props.app_home_color_primary ? props.app_home_color_primary : "black"};
  z-index: 1;
  font-size: 1.4rem;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;

const Button = styled.button`
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  background: ${(props) =>
    props.disabled
      ? "gray"
      : props.app_home_color_primary
      ? props.app_home_color_primary
      : "black"};
  border-style: none;
  z-index: 1;
  disabled: ${(props) => (props.disabled ? props.disabled : false)};
  font-size: 1.4rem;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;

const FlexContainer = styled.div`
  max-width: 120rem;
  display: flex;
  margin: auto;
  padding: 0 2rem;
  justify-content: space-between;
  height: 5rem;
`;
